<template>
  <div>
    <superslide :options="options" class="slideBox" v-if="list.length>0">
      <!-- slides -->
      <div class="bd">
        <ul>
          <li v-for="item in list">
            <a v-if="item.map.href_url" :href="item.map.href_url">
              <img :src="item.map.pic"/>
            </a>
            <img v-else :src="item.map.pic"/>
          </li>
        </ul>
      </div>

      <!-- Optional controls -->
      <!-- slot="pagination" -->
      <div class="hd" slot="titCell">
        <ul>
          <li :class="options.defaultIndex==index ? 'on':''" v-for="(item,index) in list" @click="liClick(index)">
            {{ index + 1 }}
          </li>
        </ul>
      </div>

      <!-- slot="prev" -->
      <a class="prev" href="javascript:void(0)" slot="prev"></a>
      <!-- slot="next" -->
      <a class="next" href="javascript:void(0)" slot="next"></a>

      <!-- slot="pageStateCell" -->
      <span class="pageState" slot="pageStateCell"></span>
    </superslide>
  </div>
</template>

<script>
import {queryBanners, queryOrderCount} from "@/api/home";

export default {
  name: 'index-banner',
  data() {

    return {
      list: [],
      orderCount: {},
      queryParams: {
        groupName: 'tengen_home_banner_pc'
      },
      options: {
        titCell: ".hd li",
        mainCell: ".bd ul",
        autoPlay: true,
        effect: "fold",
        defaultIndex: 0
      }
    }
  },
  created() {
    this.queryBannerFun()
    // this.queryOrderCountFun()
  },
  methods: {
    liClick(index) {
      console.log(index)
      this.options.defaultIndex = index
    },
    queryBannerFun() {
      queryBanners(this.queryParams).then(res => {
        console.log(res)
        this.list = res
      })
    },

  },

}
</script>

<style scoped="scoped" lang="less">

</style>